<div>
  <ng-content></ng-content>
</div>
<svg-icon
  class="app-accordion-expansion-indicator"
  [src]="'/assets/icons/' + (isExpanded() ? 'icon-arrow-up.svg' : 'icon-arrow-down.svg')"
></svg-icon>
